/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FileArrowUpRegularV6 = (props) => (
  <Icon {...props} name="File Arrow Up Regular V6">
    <path d="m7.469 6.969-2.5 2.5A.75.75 0 1 0 6.03 10.53l1.221-1.22v3.191a.75.75 0 0 0 1.5 0V9.31l1.22 1.22c.146.149.337.221.53.221s.384-.073.53-.22a.75.75 0 0 0 0-1.061l-2.5-2.5a.754.754 0 0 0-1.062-.001zm5.947-4.051L11.084.585a2.01 2.01 0 0 0-1.415-.586H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8c1.1 0 2-.9 2-2V4.33a2 2 0 0 0-.584-1.413zM12.5 14a.5.5 0 0 1-.5.5H4.001a.5.5 0 0 1-.5-.5L3.5 2.004a.5.5 0 0 1 .5-.5h5V4a1 1 0 0 0 1 1h2.472v9h.028z" />
  </Icon>
);

export default FileArrowUpRegularV6;
